import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_2 = {
  key: 0,
  class: "tooltip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass([$setup.isH5 ? 'feedback-container-h5' : '', 'feedback-container'])
    }, [
      _createElementVNode("div", {
        class: "feedback-like",
        onMouseenter: _cache[0] || (_cache[0] = ($event: any) => ($setup.isLikeIconHover = true)),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => ($setup.isLikeIconHover = false)),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.onLikeIconClick && $setup.onLikeIconClick(...args)))
      }, [
        _createVNode(_component_Icon, {
          file: $setup.likeIcon,
          width: "16px",
          height: "16px"
        }, null, 8, ["file"]),
        ($setup.isPC)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createTextVNode(_toDisplayString($setup.TUITranslateService.t("AIDesk.满意")) + " ", 1),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "tooltip-arrow" }, null, -1))
            ]))
          : _createCommentVNode("", true)
      ], 32),
      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "divider" }, null, -1)),
      _createElementVNode("div", {
        class: "feedback-dislike",
        onMouseenter: _cache[3] || (_cache[3] = ($event: any) => ($setup.isDislikeIconHover = true)),
        onMouseleave: _cache[4] || (_cache[4] = ($event: any) => ($setup.isDislikeIconHover = false)),
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.onDislikeIconClick && $setup.onDislikeIconClick(...args)))
      }, [
        _createVNode(_component_Icon, {
          file: $setup.dislikeIcon,
          width: "16px",
          height: "16px"
        }, null, 8, ["file"]),
        ($setup.isPC)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createTextVNode(_toDisplayString($setup.TUITranslateService.t("AIDesk.不满意")) + " ", 1),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "tooltip-arrow" }, null, -1))
            ]))
          : _createCommentVNode("", true)
      ], 32)
    ], 2)
  ]))
}